import ElevatedTile from "../components/object-graphics/TileElevated";
import { TILES } from "../helpers/tiles";
import { BodyPlacement } from "./BodyPlacement";
import { DIRECTION_LEFT, PLACEMENT_TYPE_HERO } from "../helpers/consts";

export class CiabattaBulletPlacement extends BodyPlacement {
  constructor(properties, level) {
    super(properties, level);

    this.waitFramesBeforeAIMove = 7;
    this.framesUntilAiMove = this.waitFramesBeforeAIMove;
    this.isImmuneToIce = true;
    this.isImmuneToConveyor = true;
    this.isImmuneToWallSwitch = true;

    this.pattern = properties.pattern || [DIRECTION_LEFT];
    this.movesLeft = 35;
  }

  _handleAIMove() {
    this._move(this.pattern[0]);
    this.pattern.push(this.pattern.shift());

    this.movesLeft -= 1;
    if (this.movesLeft === 0) {
      this.level.removeLivePlacement(this);
    }
  }

  damagesBodyOnCollide(forBody) {
    return forBody.type === PLACEMENT_TYPE_HERO;
  }

  handleEnemyCollideWithHero() {
    this.level.setDeathType(this.type);
  }

  renderComponent() {
    return <ElevatedTile frameCoord={TILES.CIABATTA_BLAST} pxAboveGround={6} />;
  }
}
